export enum MfaMethod {
  SMS = 'SMS_MFA',
  TOTP = 'SOFTWARE_TOKEN_MFA',
  None = 'NONE',
}

export const MFA_METHOD_LABELS: Record<MfaMethod, string> = {
  [MfaMethod.SMS]: 'SMS (Recommended)',
  [MfaMethod.TOTP]: 'Authenticator app',
  [MfaMethod.None]: 'None',
};

/** A user's Cognito status, with Cognito's own values. */
export enum AccountStatus {
  Unconfirmed = 'UNCONFIRMED',
  Confirmed = 'CONFIRMED',
  Unknown = 'UNKNOWN',
  ResetRequired = 'RESET_REQUIRED',
  ForceChangePassword = 'FORCE_CHANGE_PASSWORD',
  Archived = 'ARCHIVED',
  Compromised = 'COMPROMISED',
  ExternalProvider = 'EXTERNAL_PROVIDER',
}

export const ACCOUNT_STATUS_LABELS: Record<AccountStatus, string> = {
  [AccountStatus.Unconfirmed]: 'Pending email confirmation',
  [AccountStatus.Confirmed]: 'Ready',
  [AccountStatus.Unknown]: 'Unknown',
  [AccountStatus.ResetRequired]: 'Password reset required',
  [AccountStatus.ForceChangePassword]: 'Awaiting login using temporary password',
  [AccountStatus.Archived]: 'Archived',
  [AccountStatus.Compromised]: 'Compromised',
  [AccountStatus.ExternalProvider]: 'External provider',
};
